import { ActivatedRoute, RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { Component, inject, OnInit } from '@angular/core';
import { NavService } from '../nav/service/nav.service';
import { Title } from '@angular/platform-browser';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Article, ArticleService } from '../admin/shared/public-api';
import { ArticleCardComponent } from '../shared/components/article-card/article-card.component';
import { DeviceService } from '../shared/services/device.service';
import { MetaService } from '../shared/services/meta.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  imports: [CommonModule, ArticleCardComponent, NgOptimizedImage, RouterModule],
})
export class ContactComponent implements OnInit {
  private readonly articleService = inject(ArticleService);
  private readonly navService = inject(NavService);
  protected readonly deviceService = inject(DeviceService);
  private readonly metaTagService = inject(MetaService);
  lastArticles: Observable<Article[]>;

  constructor(route: ActivatedRoute, titleService: Title) {
    if (route.snapshot.data && route.snapshot.data['name']) {
      titleService.setTitle(route.snapshot.data['title']);

      const baseUrl = environment.baseUrl;
      const description = `Contacter les Explorateurs du Monde!`;

      this.metaTagService.updateMetaTags(
        description,
        route.snapshot.data['title'],
        baseUrl + 'contact',
        'website',
        `${baseUrl}/contact/contact.jpg`,
        1500,
        1000,
        'image/jpeg',
      );
    }
  }

  ngOnInit(): void {
    this.navService.setGreenBackground();
    this.lastArticles = this.articleService.getArticles(0, 3);
  }
}
